import {cerrarSesion} from '../utilities/Seguridad'
import axios from 'axios'

export async function getTotalDashborad(token,idColegio,anio) {

  let config = {
    method: 'get',
    url: `${process.env.REACT_APP_URL}/dashboard/${idColegio}/${anio}`,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  };

  const response = await axios(config)
    .then((response) => {
      if(response.data.error===1) cerrarSesion(response.data);
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      return null;
    });
  return response;
}


  